import { Injectable } from '@angular/core';
import {
  ApplianceList,
  Firm
} from '../../app/modules/chart/interface/interfaces';
import { Actions, AppStore } from '../index';
import { ReduxAction, ReduxType } from '../interface';

@Injectable()
export class ApplianceActions extends Actions {
  constructor(appStore: AppStore) {
    super(appStore);
  }

  public storeApplianceList(filter: ApplianceList): ReduxAction<ApplianceList> {
    return { type: ReduxType.APPLIANCE_LIST, payload: filter };
  }
  public selectedApplianceId(firm: Firm): ReduxAction<Firm> {
    return { type: ReduxType.SELECTED_APPLIANCE_ID, payload: firm };
  }
}
